var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      style: { "font-family": "Poppins" },
      attrs: { id: "lex-web", "ui-minimized": _vm.isUiMinimized }
    },
    [
      _c("min-button", {
        attrs: {
          "toolbar-color": _vm.toolbarColor,
          "is-ui-minimized": _vm.isUiMinimized
        },
        on: { toggleMinimizeUi: _vm.toggleMinimizeUi }
      }),
      !_vm.isUiMinimized
        ? _c(
            "v-content",
            [
              _c(
                "v-container",
                {
                  staticClass: "message-list-container",
                  class: "toolbar-height-" + _vm.toolbarHeightClassSuffix,
                  style: {
                    top: this.isiOS ? "" : "56px",
                    height: this.isiOS
                      ? "calc(100% - 2 * 10vw)"
                      : "calc(100% - 2 * 23vw)",
                    marginTop: (50 % -_vm.status_height) + "px"
                  },
                  attrs: { fluid: "", "pa-0": "" }
                },
                [
                  !_vm.isUiMinimized
                    ? _c("message-list", {
                        attrs: {
                          id: "msg",
                          "toolbar-logo": _vm.toolbarLogo,
                          "loading-gif": _vm.LoadingGif,
                          isTextFocus: _vm.isTextFocus
                        },
                        on: { sendToken: _vm.send }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isSFXOn
        ? _c("div", { attrs: { id: "sound", "aria-hidden": "true" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }